/* eslint-disable import/first,no-func-assign */
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from 'react';

var SvgEdgeLogDelivery = props => /*#__PURE__*/React.createElement("svg", _extends({}, props, {
  viewBox: "0 0 64 64",
  xmlns: "http://www.w3.org/2000/svg",
  "aria-hidden": !props['aria-label'],
  focusable: "false"
}), /*#__PURE__*/React.createElement("path", {
  d: "M48.795 30.0139V34.0139H19.795V46.0139H48.795V50.0139H45.685V56.0239L43.685 58.0239H7.83496L5.83496 56.0239V8.02393L7.83496 6.02393H27.765L29.175 6.60393L45.105 22.6039L45.685 24.0139V30.0139H48.795ZM38.885 21.9539L29.755 12.7739V21.9539H38.885ZM41.685 49.9739H17.755L15.765 47.9239V31.9239L17.765 29.9239H41.685V25.9239H27.755L25.755 23.9239V9.92393H9.83496V53.9239H41.685V49.9739Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M22.9072 43.2086L25.7847 35.434L29.536 36.8224L26.6585 44.597L22.9072 43.2086Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M34.7886 35.4339L31.9111 43.2085L35.6624 44.5969L38.5399 36.8223L34.7886 35.4339Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M49.7017 36.0504L51.7617 33.9804L57.7917 40.0204L51.7617 46.0504L49.7017 43.9904L52.2117 41.4704H43.2617V38.5604H52.2117L49.7017 36.0504Z"
}));

export default SvgEdgeLogDelivery;